import React, { useState } from 'react'
import { Modal, Button, Col, Form, Input, Radio, Row, Tag } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import _, { isNull } from 'lodash'

const UpdateCoinAllHero = ({ visibleCoin, onOkCoin, onCloseModalCoin ,form }) => {
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const name = localStorage.getItem('user-name')
        const data = {
          amount: values.amount,
          transactionFlag: 1,
          transactionAction: name + " [ADMIN]"
        }
        onOkCoin(data)
      }
    })
  }

  return (
    <Modal
      title="Update coin to all hero"
      visible={visibleCoin}
      footer={null}
      onCancel={onCloseModalCoin}>
      <Form onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Amount">
          {getFieldDecorator(`amount`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(<Input type="number" min="1" />)}
        </Form.Item>
        {/* <Form.Item label="">
          {getFieldDecorator(`transactionFlag`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group>
              <Radio value={1}>
                <Tag color='Green'>
                  +
                </Tag>Coin</Radio>
            </Radio.Group>
          )}
        </Form.Item> */}
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCloseModalCoin()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedUpdateCoinAllHero = Form.create({ name: 'UpdateCoinAllHero' })(UpdateCoinAllHero)
export default WrappedUpdateCoinAllHero